import React from 'react'
import { getFormValues, reset } from 'redux-form'
import { TABLA_BUQUES } from '../../../config/tables'
import { COLUMNS_LISTADO_BUQUES, COLUMNS_LISTADO_BUQUES_TO_PRINT } from './constantesBuque'
import { FORM_EDICION_BUQUE, FORM_BUQUES } from '../../../config/forms'
import { pdfCustomToolbarGenerator } from '../../../models/tools/generarPdf'
import Buque from '../../../models/buque/buque'
import { toast } from 'react-toastify'
import { COLORES } from '../../../config/colores'
import { Button } from '@material-ui/core'
import AgregarBuqueDialog from '../components/AgregarBuqueDialog'
import { updateBuqueAnunciado } from './TablaBuquesAnunciadosActions'

export function submitNuevoBuque () {
  return (dispatch, getState) => {
    const state = getState()
    const buqueValues = getFormValues(FORM_BUQUES)(state)
    buqueValues.nombre = (buqueValues.nombre).toUpperCase()
    buqueValues.nombreCorto = (buqueValues.nombreCorto).toUpperCase()
    console.log(buqueValues)
    Buque.insertBuque(buqueValues)
      .then((response) => {
        if (!response.error) {
          if (buqueValues.bodegas && buqueValues.bodegas > 0) {
            for (let index = 1; index <= buqueValues.bodegas; index++) {
              Buque.insertarBodegasBuque(buqueValues.nombreCorto, index)
            }
          }
          toast.success(`Se agrego correctamente el buque ${buqueValues.nombre}`)
          dispatch(actualizarDatosParaMuiTable())
          dispatch(reset(FORM_BUQUES))
        } else {
          console.log(response)
          toast.error('Error al intentar agregar un buque.')
        }
      })
      .catch(() => {
        toast.error('Error al intentar agregar un buque')
      })
  }
}

export function openAgregarBuqueDialog () {
  return (dispatch, getState) => {
    const confirmCallback = () => {
      submitNuevoBuque()(dispatch, getState)
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'AGREGAR_BUQUE'
      })
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'AGREGAR_BUQUE'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'AGREGAR_BUQUE',
      maxWidth: 'md',
      content: <AgregarBuqueDialog
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
      />
    })
    dispatch({
      type: 'OPEN_AGREGAR_BUQUE'
    })
  }
}

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_BUQUES
    })
    Buque.getBuques().then(callback)
    function callback (data) {
      const customToolbar = () => {
        return (
          <>
            { pdfCustomToolbarGenerator(
              'Listado de Buques',
              data,
              COLUMNS_LISTADO_BUQUES_TO_PRINT,
              'landscape') }
            { <div className='container-btn-toolbar btn-toolbar'>
              <Button
                variant='contained'
                style={{ color: COLORES.blue.primary, width: '100%', fontWeight: 'bold' }}
                size='small'
                onClick={() => { dispatch(openAgregarBuqueDialog()) }}
              >
              NUEVO BUQUE
              </Button>
            </div> }
          </>
        )
      }
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_LISTADO_BUQUES,
          data: data,
          title: `Listado de Buques`,
          isLoading: false,
          extraOptions: { customToolbar, print: false, rowsPerPage: 50, rowsPerPageOptions: [50, 100, 500] }
        },
        id: TABLA_BUQUES
      })
    }
  }
}

export function getConsultaBuque (nombre, callback) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_BUQUE' })
    Buque.getDatosBuque(nombre)
      .then(consultaBuque => {
        dispatch({ type: 'RECEIVE_CONSULTA_BUQUE', consultaBuque })
        callback && callback(consultaBuque)
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_CONSULTA_BUQUE',
        consultaBuque: null
      }))
  }
}

export function submitUpdateBuque (edicionDesdeAnunciados = false) {
  return (dispatch, getState) => {
    const state = getState()
    const buqueValues = getFormValues(FORM_EDICION_BUQUE)(state)
    buqueValues.nombre = (buqueValues.nombre).toUpperCase()
    buqueValues.nombreCorto = (buqueValues.nombreCorto).toUpperCase()
    console.log('BuqueValues', buqueValues)
    Buque.updateBuque(buqueValues)
      .then((saveStatus) => {
        dispatch({ type: 'UPDATE_BUQUE' })
        console.log(saveStatus)
        if (!saveStatus.error) {
          toast.success('Datos del Buque actualizados exitosamente.')
          if (edicionDesdeAnunciados) {
            dispatch(updateBuqueAnunciado())
          } else {
            dispatch(actualizarDatosParaMuiTable())
            dispatch(reset(FORM_BUQUES))
          }
        } else {
          toast.error('Error al actualizar los datos del Buque.', { autoClose: false })
        }
      })
      .catch(() => {
        dispatch({ type: 'ERROR_UPDATE_BUQUE' })
        toast.error('Error al actualizar los datos del Buque.', { autoClose: false })
      })
  }
}
